function readAccess(fieldPermissions, fieldName) {
  if (!fieldPermissions || !fieldName) {
    return undefined;
  }

  const permission = fieldPermissions[fieldName];
  if (!permission) {
    return undefined;
  }

  return permission.access !== undefined ? permission.access : permission.Access;
}

export default function canShowField({ fieldName, fieldPermissions }) {
  return readAccess(fieldPermissions, fieldName) !== 0;
}
